/**
 * @generated SignedSource<<66c6a20ef2db953e4dfd1d1332610cd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DiskCleanerInput = {
  media?: DiskCleanerMediaInput | null;
  storage?: DiskCleanerStorageInput | null;
};
export type DiskCleanerMediaInput = {
  selected?: boolean | null;
};
export type DiskCleanerStorageInput = {
  selected?: boolean | null;
};
export type DiskCleanupMutation$variables = {
  input?: DiskCleanerInput | null;
};
export type DiskCleanupMutation$data = {
  readonly diskCleanerClean: {
    readonly total: {
      readonly count: number;
      readonly size: string;
    };
  };
};
export type DiskCleanupMutation = {
  response: DiskCleanupMutation$data;
  variables: DiskCleanupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DiskCleanerResult",
    "kind": "LinkedField",
    "name": "diskCleanerClean",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CleanInfo",
        "kind": "LinkedField",
        "name": "total",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiskCleanupMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiskCleanupMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3fc5102fd9fb922aea26d600ba8a9710",
    "id": null,
    "metadata": {},
    "name": "DiskCleanupMutation",
    "operationKind": "mutation",
    "text": "mutation DiskCleanupMutation(\n  $input: DiskCleanerInput\n) {\n  diskCleanerClean(input: $input) {\n    total {\n      count\n      size\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b1686a0a556d9e390abf63756114f19";

export default node;
